/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 11:02:28
 * @LastEditors: zhangsheng
 * @LastEditTime: 2023-09-25 15:35:46
 * @FilePath: \panda-index-sicermem-frontend\src\locales\en-US\contactUs.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'ContactUs.index.101073-0': 'Shanghai SICERMEM Technology Co. Ltd.',
  'ContactUs.index.101073-1': 'Phone：',
  'ContactUs.index.101073-2': 'Email：',
  'ContactUs.index.101073-3': 'Address：',
  'ContactUs.index.101073-4': '5A/F, No. 5888 Jiasong Middle Road, Qingpu District, Shanghai',

  'Counselling.index.267509-0': 'Successfully Submitted',
  'Counselling.index.267509-1': 'Online inquiry',
  'Counselling.index.267509-2': 'Please leave a message below and we will contact you as soon as possible',
  'Counselling.index.267509-3': 'Contacts',
  'Counselling.index.267509-4': 'Company Name',
  'Counselling.index.267509-5': 'Mobile Phone',
  'Counselling.index.267509-6': 'Telephone',
  'Counselling.index.267509-7': 'Please enter the correct format for the landline phone number',
  'Counselling.index.267509-8': 'Fax',
  'Counselling.index.267509-9': 'Please enter the correct format for the fax phone number',
  'Counselling.index.267509-10': 'Email',
  'Counselling.index.267509-11': 'Please enter an email address in the correct format',
  'Counselling.index.267509-12': 'Product Name',
  'Counselling.index.267509-13': 'Quantity',
  'Counselling.index.267509-14': 'Packaging requirements',
  'Counselling.index.267509-15': 'Other instructions',
  'Counselling.index.267509-16': 'Submit',

  'JoinUs.index.379095-0': 'people',
  'JoinUs.index.379095-1': 'Job responsibilities',
  'JoinUs.index.379095-2': 'Job requirements',

  'JoinUs.index.022321-0': 'Process Engineer',
  'JoinUs.index.022321-1':
    '1. Develop a project design schedule, responsible for completing equipment selection, design schemes, and drawing design and construction drawings. 2. Complete all technical work during project implementation, including technical disclosure, design changes, project construction, and completion documents.',
  'JoinUs.index.022321-2':
    '1. At least 2 years of work experience in environmental engineering or water supply and drainage. 2. Having design experience in sewage treatment engineering and municipal water supply engineering, understanding the application of sewage treatment technology and membrane technology in the field of sewage treatment. 3. Proficient in using CAD drawing and office software.',
  'JoinUs.index.022321-3': 'Sales Engineer for Flat Film',
  'JoinUs.index.022321-4':
    "1. Collect and analyze market information, provide timely feedback to customers, and propose effective market operation and sales suggestions. 2. According to the company's market strategy, actively explore new markets, maintain customer relationships, and expand business volume. 3. Understand, analyze, and provide feedback on market competition.",
  'JoinUs.index.022321-5':
    '1. Responsible for the sales of flat ceramic membrane products and wastewater treatment engineering. 2. Having sales experience in reclaimed water reuse and wastewater treatment industry is preferred. Familiar with water treatment membranes or MBR membranes is preferred. 3. Develop and maintain channels for engineering companies and related distribution partners. 4. Good communication and coordination skills, strong expression skills, and outstanding execution skills. 5. Good professional ethics and dedication.',
  'JoinUs.index.022321-6': 'Ceramic Film Sales Engineer',
  'JoinUs.index.022321-7':
    "1. Collect and analyze market information, provide timely feedback to customers, and propose effective market operation and sales suggestions. 2. According to the company's market strategy, actively explore new markets and customers, maintain customer relationships, and expand business volume. 3. Understand, analyze, and provide feedback on market competition, and assist in conducting market research on similar product information.",
  'JoinUs.index.022321-8':
    '1. Responsible for the sales of tubular ceramic membranes, components, and equipment. 2. Experience in ceramic film sales is preferred, and familiarity with ceramic film applications is a plus. 3. Proficient in mastering market information, possessing keen market observation and judgment. 4. Good communication and coordination skills, strong expression skills, and outstanding execution skills. 5. Able to independently organize and coordinate work, with good professional ethics.',

  'ContactUs.index.792848-0': 'Contact Us',
  'ContactUs.index.792848-1': 'Join Us',
  'ContactUs.index.792848-2': 'Online Consultation',

  'ContactUs.index.792848-3': 'en/contact',
  'ContactUs.index.792848-4': '/en/contact',
  'ContactUs.index.792848-5': '/en/contact/joinus',
  'ContactUs.index.792848-6': '/en/contact/counselling',
  'ContactUsAddress': 'Room 102, 1st Floor, No. 88, Lane 128, Shan Hua Road, Xinzhuang Town, Minhang District, Shanghai',
};
